import { useContext } from 'react';
import Progress from "../Progress/Progress";
import DownloadUploadSection from './DownloadUploadSection';
import { GlobalContext } from "../../../context/GlobalContext";

import "./DownloadAttachment.scss";
import { useTranslation } from "react-i18next";
import CardButtonLeftArrow from "../../../assets/CardButtonLeftArrow.svg";

function DownloadAttachment({ rtl }: any) {
  const { t } = useTranslation();
  const [state, dispatch]: any = useContext(GlobalContext);
  const { productType } = state;

  const dir = rtl ? 'right' : 'left';

  const handleBack = () => {
    dispatch({ type: 'SET_BACK_BUTTON', payload: { page: productType === "Voice" && productType === "Data" ? t("Delivery_Details") : t("Product_Information") } })
  }
  return (
    <>
      <div className="container">
        <div className="row">
        <div className="col-sm-12 d-flex">
            <div className={`back-icon-container ${dir}`} onClick={handleBack}>
              <img className={`back-icon`} src={CardButtonLeftArrow} alt="arrow" />
            </div>
            <Progress rtl={rtl} title={t('Download_Attach')} />
          </div>
          <div className={`col-sm-12 upload-attachment-container da-${dir} order-detail-popup`}>
            <DownloadUploadSection rtl={rtl} />
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadAttachment;
